<div class="hero-background" [ngClass]="{'-no-bgimg': !(backgroundImage$ | async)}"
    directive-draw-collapse directive-draw-offset="false" directive-image-preload [background]="true" [url]="backgroundImage$ | async">
    <shared-bg-gradient></shared-bg-gradient>
    <shared-bg-overlay></shared-bg-overlay>

    <div class="hero-background__container" directive-draw-opacity>
        <div class="hero-background__wrapper wrapper">
            <div class="hero-background__row row">

                <div class="hero-background__content col">

                    <ng-container [ngSwitch]="true">
                        <ng-container *ngSwitchCase="!!(isHomePage$ | async)">
                            <ng-template #forHomeLocation>
                                <shared-search-for-locations-hero></shared-search-for-locations-hero>
                            </ng-template>
                            <ng-template #forHomeVenue>
                                <shared-pickup-for-hero></shared-pickup-for-hero>
                            </ng-template>

                            <projection-for-location-mode [location]="forHomeLocation" [venue]="forHomeVenue">
                            </projection-for-location-mode>
                        </ng-container>

                        <shared-hero-header preTitle="LOOKS LIKE WE ARE LOST"
                            *ngSwitchCase="!!(isError404Page$ | async)">
                            404 Page not found :(
                        </shared-hero-header>

                        <shared-locations-hero-header
                            *ngSwitchCase="((isLocationDetailsPage$ | async) && (isCurrentLocationValid$ | async))"
                            [locationNo]="currentLocationNo$ | async">
                        </shared-locations-hero-header>

                        <shared-account-member-hero-header *ngSwitchCase="!!(isAccountPage$ | async)">
                        </shared-account-member-hero-header>

                        <shared-order-confirmation-hero-header
                            *ngSwitchCase="showOrderConfirmationHeroHeader && !!(isOrderConfirmationPage$ | async)">
                        </shared-order-confirmation-hero-header>

                        <shared-loyalty-hero-header *ngSwitchCase="!!(isLoyaltyPage$ | async)">
                        </shared-loyalty-hero-header>

                    </ng-container>
                </div>

            </div>
        </div>
    </div>
</div>
